// src/routesMap.js
import { lazy } from "react";

// This maps your raw paths (like "/about", etc.) to localized versions.
export const routesMap = {
  "/": { it: "/", en: "/en" },
  "/listino": { it: "/listino", en: "/en/product-list" },
  "/privacy": { it: "/privacy", en: "/en/privacy" },
  "/404": { it: "/404", en: "/en/404" },
};

// Lazy-load each page component
export const lazyRoutes = {
  Home: lazy(() => import("./pages/Home")),
  Listino: lazy(() => import("./pages/Listino")),
  PrivacyPolicy: lazy(() => import("./pages/Privacy")),
  NotFound: lazy(() => import("./pages/Listino")),
};

// Shared components to avoid duplication
export const sharedComponents = {
  ContactForm: lazy(() => import("./components/Form")),
  Footer: lazy(() => import("./components/Footer")),
};

// Utility to pick the correct localized route
export const getLocalizedRoute = (path, language) => {
  return routesMap[path]?.[language] || path;
};
